import { source_channel } from '../source_channel'
import mpx from '@mpxjs/core'
import { ORDER_SOURCE } from '../constant'

/**
 * @desc 天眼共有属性添加
 * @param {*} newAttrs
 */
function addRavenCommonAttrs(newAttrs = {}, newGlobalAttrs = {}) {
  return {
    ...newAttrs,
    ...newGlobalAttrs
  }
}

/**
 * 获取系统信息
 */
async function getSystemInfo() {
  return new Promise(resolve => {
    mpx.getSystemInfo?.({
      success: res => {
        resolve(res)
      },
      fail: () => {
        resolve(null)
      }
    })
  })
}

/**
 * 获取小程序运行环境信息
 * @return {{buildPkgTime: string}}
 */
const getEnvironmentInfo = () => {
  const envInfo = {
    buildPkgTime: process.env.buildPkgTime // 打包时间
  }
  if (mpx.canIUse?.('getAccountInfoSync')) {
    const { miniProgram } = mpx.getAccountInfoSync() || {}
    if (miniProgram.envVersion === 'release') {
      // 线上版本去掉 console.log
      console.log = () => {}
    }
    envInfo.env = miniProgram.envVersion //  环境 'develop' | 'trial' | 'release'
    envInfo.version = miniProgram.version // 小程序线上版本号
  }
  return envInfo
}

export const getRavenAttr = commonAttrs => {
  let globalAttrs = {}
  const envInfo = getEnvironmentInfo()
  globalAttrs = addRavenCommonAttrs(commonAttrs, {
    buildPkgTime: envInfo.buildPkgTime,
    miniAppEnv: envInfo.env,
    miniAppVersion: envInfo.version,
    source_channel: source_channel(),
    order_source:ORDER_SOURCE
  })

  // 如果是在主端小程序运行的 那么获取下app_version
  // if (is('passenger') || __mpx_mode__ === 'dd' && __ddConfig && __ddConfig.platform !== 'devtools') {
  //   const version = getVersion()
  //   alert(version)
  //   globalAttrs.app_version = version
  // }

  return getSystemInfo().then(data => {
    if (data) {
      globalAttrs = addRavenCommonAttrs(globalAttrs, {
        // wxSDKVersion: data.SDKVersion,
        platform: data.platform,
        screenHeight: data.screenHeight,
        screenWidth: data.screenWidth,
        manufacturer: data.brand,
        model: data.model,
        system: data.system
      })
      return globalAttrs
    }
  })
}
